import {
  Component,
  Input,
  inject,
  input,
  output,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ContactListMember } from 'src/app/model/contacts/contact-list-member';
import { BaseComponent } from 'src/app/core/components/base.component';
import { ThemeService } from 'src/app/services/theme.service';
import { LowerCasePipe } from '@angular/common';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-contact-list-card',
  templateUrl: './contact-list-card.component.html',
  styleUrls: ['./contact-list-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [LowerCasePipe, TranslatePipe],
})
export class ContactListCardComponent extends BaseComponent {
  private _themeService = inject(ThemeService);

  private lIndex!: number;
  @Input() set index(i: number) {
    this.lIndex = i + 1;
  }
  get index(): number {
    return this.lIndex;
  }
  @Input() member!: ContactListMember;
  readonly openProfileEvent = output<any>();
  readonly selectEvent = output<any>();

  readonly selected = input(false);

  openProfile(id: string | null = null) {
    if (!id) {
      id = this.member.contact!.id;
    }
    this.openProfileEvent.emit(id);
  }

  cardClassName() {
    const selectedTheme = this._themeService.getSelectedTheme();
    const isDark = selectedTheme === 'dark';
    const classAdjust = isDark ? '-dark' : '';

    // Check if contact is unavailable
    if (
      this.member.contact!.isUnavailable === 'TRUE' ||
      this.member.contact!.inactiveAdAccount
    ) {
      return (
        'ui-helper-clearfix contact-list-item contact-list-item-unavail' +
        classAdjust
      );
    }

    // Check if contact is currently scheduled
    else if (this.member.isScheduled) {
      return (
        'ui-helper-clearfix contact-list-item contact-list-item-scheduled' +
        classAdjust
      );
    } else {
      return (
        'ui-helper-clearfix contact-list-item contact-list-item-avail' +
        classAdjust
      );
    }
  }
}
